/**
 * Application Constants
 * Centralized constants for better maintainability
 */

// API Endpoints

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_DATA: 'userData',
  COMPANY_DATA: 'companyData',
  THEME: 'theme',
  COMPANY_MODAL_DISMISSED: 'companyModalDismissed',
  SYNC_STALE: 'syncStale',
};

// App Configuration
export const APP_CONFIG = {
  NAME: 'Bizz.plus',
  VERSION: '1.0.0',
  DEFAULT_LANGUAGE: 'en',
  ITEMS_PER_PAGE: 10,
};

// Analytics Configuration
export const ANALYTICS_CONFIG = {
  AMPLITUDE_API_KEY: 'e338ded0c3e5ed6be1a4f01f604ef412',
  ENABLED: true, // Set to false to disable analytics
};
